import React from 'react'
import RGL, { WidthProvider } from "react-grid-layout";
import {useSelector} from 'react-redux'
import {CircularProgress, Grid, Paper, IconButton, makeStyles} from '@material-ui/core'
import {ArrowForwardIos, ArrowBackIos} from '@material-ui/icons'
import GroupGoal from './CompStatus/gruppMål'
import CompStatus from './CompStatus'
import LeaderBoard from './Leaderboard'
import {isEmpty} from 'lodash'
import moment from 'moment-timezone'
import { injectIntl } from 'react-intl';
const ReactGridLayout = WidthProvider(RGL);

const useStyles = makeStyles({
  timerContainer: {
    position: 'fixed',
    width: '100%',
    height: 'calc(100% - 245px)',
    display: 'flex',
    alignItems:'center',
    justifyContent: 'center',
    left: 0
  },
  timerText: {
    fontSize: 60,
    fontWeight: 500,
    textAlign: 'center',
    lineHeight: '55px',
    color: 'rgb(68, 209, 194)',
    ['-webkit-text-stroke']: '4px rgb(84, 243, 227)'
  },
  timerTextRub: {
    fontSize: 30,
    textAlign: 'center',
    color: '#fff',
    fontWeight: 500,
  },
});

function DashBoardTavlingItem(props) {

  const classes = useStyles()

	const [intervalID, setintervalID] = React.useState(0)

  const DashboardCompetitionLoading = useSelector(state => state.DashBoard.DashboardCompetitionLoading)
  // const currentDashboardCompetition = useSelector(state => state.DashBoard.currentDashboardCompetition)
  const [hasStarted, setHasStarted] = React.useState(false)
  const [timeLeft, setTimeLeft] = React.useState('00:00:00')

  const setTimer = (compStart) =>  {
    let _hasStarted = moment().diff(compStart) > 0

    let duration = moment.duration(moment(compStart).diff(moment()), 'millisecond')

    let hours = duration.hours().toString()
    hours = hours.length <= 1 ? '0'+hours : hours

    let minutes = duration.minutes().toString()
    minutes = minutes.length <= 1 ? '0'+minutes : minutes

    let seconds = duration.seconds().toString()
     seconds = seconds.length <= 1 ? '0'+seconds : seconds

    let days = duration.days()
    days = days <= 0 ? '' : `${days}:`

    setHasStarted(_hasStarted)
    setTimeLeft(`${days}${hours}:${minutes}:${seconds}`)
  }

  React.useEffect(() => {
    if(!isEmpty(props.currentDashboardCompetition)) {
			setTimeLeft('00:00:00')
			setHasStarted(false)
			const interval = setInterval(() => {
				if(!isEmpty(props.currentDashboardCompetition)) setTimer(props.currentDashboardCompetition.compStart)
			}, 1000);
			setintervalID(interval)
		}
    return () => {
      clearInterval(intervalID)
    }
  },[props.currentDashboardCompetition])

  if(DashboardCompetitionLoading && isEmpty(props.currentDashboardCompetition)) return (
    <div className='d-flex h-100 w-100 align-items-center justify-content-center'>
      <CircularProgress/>
    </div>
  )
  if(isEmpty(props.currentDashboardCompetition) || timeLeft === '00:00:00') return ''
  let RestartLabel = props.intl.formatMessage({ id: 'DashBoard.contest.Restart' });
  if(!hasStarted) return (
    <>
    <div className='d-flex h-100 w-100 align-items-center justify-content-center'>
      <div className={classes.timerContainer}>
        <div>
          <p className={classes.timerTextRub}>{`${props.currentDashboardCompetition.Name} ${RestartLabel}`}</p>
          <h3 className={classes.timerText}>{timeLeft}</h3>
        </div>
      </div>
    </div>
    </>
  )
  return (
    <div className='w-100 px-2'>
      <ReactGridLayout
        className="layout"
        rowHeight={10}
      >
        
        <Paper key="1" style={{ backgroundColor: '#09585C80', color: '#fff', overflow: 'hidden' }} data-grid={{ x: 0, y: 0, w: props.Competition.intervalltype === 3 ? 5 : 12, h: 3, static: true }}>
          <CompStatus Competition={props.currentDashboardCompetition}/>
        </Paper>
        {
          (props.Competition.intervalltype === 3) ?
          <Paper key="2" style={{ backgroundColor: '#09585C80', color: '#fff', overflow: 'hidden' }} data-grid={{ x: 5, y: 0, w: 7, h: 3, static: true }}>
            <GroupGoal Competition={props.currentDashboardCompetition}/>
          </Paper>: <div key="2" data-grid={{ x: 0, y: 0, w: 0, h: 0, static: true }}></div>
        }
        <div key="3" style={{ color: '#fff', overflow: 'hidden' }} data-grid={{ x: 0, y: 3, w: 12, h: 10, static: true }}>
          <LeaderBoard Competition={props.currentDashboardCompetition}/>
        </div>
      </ReactGridLayout>
    </div>
  )
}

export default injectIntl(DashBoardTavlingItem);